// =========================
// POST VIEW
// =========================
import App from './../../App';
import { html, render } from 'lit-html';
import Auth from './../../Auth';

// This is the PostView class that handles the post page
// It includes methods for fetching a single post, rendering the page, and handling user interactions
class PostView {
  constructor() {
    this.user = Auth.currentUser;
  }

  // This method initializes the view
  // It fetches the post data based on the post ID from the URL parameters
  async init() {
    document.title = 'PopIn - Post';
    const urlParams = new URLSearchParams(window.location.search);
    const postId = urlParams.get('post');

    try {
      const res = await fetch(`${App.apiBase}/post/${postId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      if (!res.ok) throw new Error('Post not found');
      this.post = await res.json();
    } catch (err) {
      console.error('Error loading post:', err);
      this.post = null;
    }
    this.render();
  }

  render() {
    const template = html`
      <div class="layout">
        <popin-side-nav></popin-side-nav>
        <div class="main-area">
          <popin-top-bar .user=${this.user}></popin-top-bar>
          <div class="main-content feed-page">
            <popin-poster .user=${this.user}></popin-poster>
            <div id="feed-wrapper">
              <div id="feed-posts">
                ${this.post
                  ? html`<popin-post .post=${this.post}></popin-post>`
                  : html`<p style="padding: 2rem;">Post not found.</p>`}
              </div>
              <div id="feed-discover">
                <h2>Discover Events</h2>
                <div class="event-tile"></div>
                <div class="event-tile"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    render(template, App.rootEl);
  }
}

export default new PostView();
